import { NgModule } from '@angular/core';
import { LoginPage } from 'pages/login/login';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [LoginPage],
    imports: [PagesModule, ComponentsModule]
})
export class LoginPageModule {}
